/* eslint-disable */
import React, { useEffect, useState } from "react";
import queryString from 'query-string';
import { 
    Card, CardBody, Col, Container, Row
  } from 'reactstrap';
import { Button, Spinner } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import { reduxForm } from "redux-form";
import { useForm } from "react-hook-form";
import { FormField } from "@/shared/components/FormField";
import ApiServices from "@/utils/ApiServices";
import { successMsg, globalError, formError } from "../../utils/message_herlper"
import TitleBreadCrumbs from '@/components/TitleBreadCrumbs'


const StateCreate = (props) => {
    const history = useHistory()
    let search = queryString.parse(props.location.search)  
    const { handleSubmit, control, errors, formState } = useForm();
    const [isSubmit, setSubmit] = useState(false);
    const [type, setType] = useState(false);  
    const [noSubmit, setNoSubmit] = useState(0);  
    const [editData, setEditData] = useState(false);

    useEffect(() => {    
        setNoSubmit(formState?.submitCount || 0)
        if (formState.isSubmitted && Object.keys(formState?.errors).length > 0 && formState?.submitCount != noSubmit ) {
            formError()
            return
        }
    }, [formState])

    useEffect(() => {  
        let {type, id} =  props?.match?.params
        setType(type)
    }, [location]);


    const onSubmit  = (form) => {
        setSubmit(true)
        if(type === 'create'){
            ApiServices.createState(form)
            .then((result) => { 
                successMsg('STATE_SUCCESS') 
                setTimeout(() => {
                    history.push({pathname: `/states`});
                },1000)
            })
            .catch((error) => {
                setSubmit(false)
                if (error.response) {
                    console.log(error.response.data.errors)
                    // seErrors(error?.response?.data?.errors)
                    formError(error?.response?.data?.errors)
                return
                }
                globalError()
            });
        }
        if(type === 'update'){
            form.id = editData?.id 
            ApiServices.updateState(form)
            .then((result) => {  
                successMsg('STATE_UPDATE_SUCCESS') 
                setTimeout(() => {
                    history.push({pathname: `/states`});
                },1000)
            })
            .catch((error) => {
                setSubmit(false)
                if (error.response) {
                    console.log(error.response.data.errors)
                    // seErrors(error?.response?.data?.errors)
                    formError(error?.response?.data?.errors)
                return
                }
                globalError()
            });
        }
    }
    
    return (
        <Container>
            <TitleBreadCrumbs title={type === 'create' ? 'Create New State' : 'Edit State'} >
                <div className="page-breadcrumbs">
                    <Link to="/">Home</Link>
                    <Link to="/settings">Settings</Link>
                    <Link to="/states">States</Link>
                    <span className="current_breadcrumbs"> {type === 'create' ? 'Create' : 'Edit'}</span>
                </div>
            </TitleBreadCrumbs>
            <Row>
                <Col md={12}>
                    <Card className="card-controlled">
                        <CardBody className="cardbody-controlled">
                            <Row>
                                <Col md={12} className="edit-county-wrap">
                                    <form
                                        className="client-reg-form"
                                        onSubmit={handleSubmit(onSubmit)}
                                    >
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">
                                                State Name
                                            </span>
                                            <div className="form__form-group-field">
                                                <FormField
                                                    name="name"
                                                    component="input"
                                                    control={control}
                                                    errors={errors}
                                                    rules={{
                                                        required:
                                                            "This is required field",
                                                    }}
                                                    placeholder="State Name"
                                                />
                                            </div>
                                            {errors?.name && (
                                                <span className="form__form-group-error">
                                                    {errors?.name?.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">
                                                State Code
                                            </span>
                                            <div className="form__form-group-field">
                                                <FormField
                                                    name="code"
                                                    component="input"
                                                    control={control}
                                                    errors={errors}
                                                    rules={{
                                                        required:
                                                            "This is required field",
                                                    }}
                                                    placeholder="Code"
                                                />
                                            </div>
                                            {errors?.code && (
                                                <span className="form__form-group-error">
                                                    {errors?.code?.message}
                                                </span>
                                            )}
                                        </div>
                                        
                                        <div className="edit-county-btns">
                                            <Link className="btn btn-secondary" to="/states">Back to List</Link>
                                            <Button
                                            className="float-right"
                                                type="submit"
                                                color="primary"
                                                disabled={isSubmit}
                                            > {isSubmit ? <Spinner size="sm" color="secondary" className="mr-2" /> : ''}
                                                {type === 'create' ? 'Submit' : ''}
                                                {type === 'update' || type !== 'create' ? 'Save Changes' : ''}
                                            </Button>
                                        </div>

                                    </form>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default reduxForm({
    form: 'state_create',
})(StateCreate);